import React from "react";
import './Timeline.css';
import {PublicApiConsignmentResponse} from "../Representation";

interface TimelineProps {
    consignment: PublicApiConsignmentResponse
}

const Timeline = (
    { consignment }: TimelineProps
) => {

    switch (consignment.status) {
        case 'CANCELLED':
            return <ol className="timeline">
                <li>
                    <span className="status">Delivery cancelled</span><br/>
                    <span className="timestamp">{ consignment.formattedCancelledAt }</span>
                </li>
            </ol>

        case 'UNASSIGNED':
            return <ol className="timeline">
                <li>
                    <span className="status">To be scheduled</span><br/>
                </li>
            </ol>

        case 'SCHEDULED':
        case 'ASSIGNED':
            return <ol className="timeline">
                <li className="active">
                    <span className="status">Scheduled for delivery</span><br/>
                    {/*<span className="timestamp"> assigned time </span>*/}
                </li>
            </ol>

        case 'STARTED':
            return <ol className="timeline">
                <li>
                    <span className="status">Scheduled for delivery</span><br/>
                    {/*<span className="timestamp"> assigned time </span>*/}
                </li>
                <li className="active">
                    <span className="status">On it's way</span><br/>
                    {/*<span className="timestamp"> started time </span>*/}
                </li>
            </ol>

        case 'COMPLETED':
            return <ol className="timeline">
                <li>
                    <span className="status">Scheduled for delivery</span><br/>
                    {/*<span className="timestamp"> assigned time </span>*/}
                </li>
                <li>
                    <span className="status">On it's way</span><br/>
                    {/*<span className="timestamp"> started time </span>*/}
                </li>
                <li className="active">
                    <span className="status">Completed</span><br/>
                    <span className="timestamp"> {consignment.formattedCompletedAt} </span>
                </li>
            </ol>

        default:
            return <ol className="timeline">
                <li>
                    <span className="status">Unknown {consignment.status}</span><br/>
                </li>
            </ol>
    }

}

export default Timeline;
